<template>
    <Frame>
        <PageHeader :title="title" :hasBack="true" detailType="BulletinCenterDetail" ref="pageheader"/>
        <div class="body-container">
            <span class="timeinfo">{{ timeinfo }}</span>
            <div class="helpinfo" ref="innerhtml" :style="height" id="info"></div>
        </div>
    </Frame>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            html: "",
            BillNo: "",
            SendTime: "",
            username: "",
            timeinfo: "",
            height: "height:" + window.innerHeight - 237 + "px;",
        }
    },
    methods: {
    },
    created() {
        this.title = this.$route.query.Title;
        this.BillNo = this.$route.query.BillNo;
    },
    mounted() {
        let that = this
        //vue里不建议用document.getelementbyid,这里暂时先处理，后续有好方法再改动
        var info = document.getElementById("info");
        info.style.height = window.innerHeight - 187 - this.$refs.pageheader.$el.clientHeight + "px";
        window.onresize = () => {
            if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
            }
            that.resizeFlag = setTimeout(() => {
                info.style.height = window.innerHeight - 187 - this.$refs.pageheader.$el.clientHeight + "px";
                that.resizeFlag = null;
            }, 100);
        }
        this.axiosInvoke(this.sysHandlerUrl,
            {
                action: "getbulletindetail",
                BillNo: this.BillNo
            },
            (res) => {
                var data = eval(res.data);
                console.log(data);
                this.SendTime = data[0].SendTime;
                this.username = data[0].username;
                this.timeinfo = '【  ' + this.$t('BulletinCenter.publisher') + ':  ' + this.username + " " + this.$t('HelpCenter.publishtime') + ': ' + this.SendTime + '  】';
                var html = data[0].html;
                this.$refs.innerhtml.innerHTML = html;
            })
    }


}
</script>

<style scoped>
.body-container {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center
}

.timeinfo {
    width: 100%;
    padding: 20px 0;
}

.helpinfo {
    overflow: auto;
    width: 100%;
    word-break: break-all;
}
</style>